/**
 * Coordinates support-ticket unread nav badges between pages and the shell.
 *
 * Opening a ticket stamps last-viewed on the server; list rows update on the
 * next fetch, but {@link useSupportUnreadCount} only polls every 60s unless
 * something calls {@link requestSupportUnreadCountRefresh}.
 */

export type SupportUnreadCountScope = 'admin' | 'user';

const listeners: Record<SupportUnreadCountScope, Set<() => void>> = {
  admin: new Set(),
  user: new Set(),
};

/**
 * Subscribes to refresh requests for one nav badge scope.
 */
export function subscribeSupportUnreadCountRefresh(
  scope: SupportUnreadCountScope,
  listener: () => void,
): () => void {
  listeners[scope].add(listener);
  return () => {
    listeners[scope].delete(listener);
  };
}

/**
 * Asks all mounted unread-count hooks for the given scope to re-fetch immediately.
 */
export function requestSupportUnreadCountRefresh(
  scope: SupportUnreadCountScope | 'both' = 'both',
): void {
  if (scope === 'both' || scope === 'admin') {
    for (const listener of listeners.admin) {
      listener();
    }
  }

  if (scope === 'both' || scope === 'user') {
    for (const listener of listeners.user) {
      listener();
    }
  }
}
